module.exports = __webpack_public_path__ + "static/HalconMilenario-1659d0d62ca5bea9bb60e5e2f43cdaa8.jpg";